import { DISTANCE_TYPE } from '../enums/route.enum';
import { RouteDirection } from './route-direction-model';

export class SummaryData extends RouteDirection {
    Summary: string;
    Duration: Array<any> = [];
    Distance: Array<any> = [];
    legs: Array<any> = [];
    overviewPolyline: any;

    constructor(summary: string, distanceType: DISTANCE_TYPE) {
      super();
      this.Summary = summary;
      this.DistanceType = distanceType;
    }

    toggle() {
      this.DistanceType = this.getToggleDistanceType;
    }

    get getToggleDistanceType() {
      return (this.DistanceType == DISTANCE_TYPE.MILES) ? DISTANCE_TYPE.KM : DISTANCE_TYPE.MILES;
    }

    get formatDistance() {
      let total: any = 0;
      for (let i = 0; i < this.Distance.length; i++) {
        total += this.Distance[i].value;
      }
      return (total / this.getDistanceFormat() ).toFixed(1) + ' ' + this.DistanceType;
    }

    get formatDuration() {
      let total: any = 0;
      for (let i = 0; i < this.Duration.length; i++) {
        total += this.Duration[i].value;
      }
      return this.timeConversion(total * 1000);
    }

    get journeyLengthForTargetting() {
      let total: any = 0;
     
      for (const item of this.Distance) {
        total += item.value;
      }

      const totalDistance = total / 1000; // 1000 for Kms
      if (totalDistance > 400) {
        return 'very_long';
      } else if (totalDistance > 150) {
        return 'long';
      } else if (totalDistance > 25) {
        return 'medium';
      } else if (totalDistance > 0) {
        return 'short';
      } else {
        return 'unknown';
      } 
    }

  }
